import styled from 'styled-components';

export const ValidationErrorWrapper = styled.div`
  background-color: ${(props) => props.theme.black};
  color: ${(props) => props.theme.white};
  padding: 0.75rem 1rem;
  border-radius: ${(props) => props.theme.borderRadius};
  margin: 0.75rem 0;
`;

export const ValidationErrorTitle = styled.div`
  font-size: ${(props) => props.theme.fontSizeBase};
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const ValidationErrorList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const ValidationErrorItem = styled.li`
  font-size: ${(props) => props.theme.fontSizeSm};
  margin: 0.3rem 0;
  text-align: left;
  &:before {
    content: '• ';
    margin-right: 0.5rem;
  }
`;
